import type { SVGProps } from "react";

const PencilIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.1667 2.5L17.5 5.83333L6.66667 16.6667L2.5 17.5L3.33333 13.3333L14.1667 2.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PencilIcon;
